import { Trans } from '@lingui/react'

import Form from 'views/components/atoms/Form'
import OffCanvasItem from 'views/components/organisms/OffCanvas/OffCanvasItem'
import withMountPoints from 'views/enhancers/withMountPoints'
import { mountPointsType } from 'views/utils/propTypes'

const OffcanvasLogoutItem = ({ mountPoints }) => (
  <Form
    name="offcanvas-logout-form"
    method="POST"
    action={mountPoints.getLogout()}
  >
    <OffCanvasItem name="off-canvas-logout" type="submit">
      <Trans id="offcanvas.link.logout" />
    </OffCanvasItem>
  </Form>
)

OffcanvasLogoutItem.propTypes = {
  mountPoints: mountPointsType.isRequired,
}

export default withMountPoints(OffcanvasLogoutItem)
